export default "__VITE_ASSET__DbP0TxUC__"